import client from "./APIClient"

export default class ChatbotApi {
  static getMessages = (thread_id) => {
    return client(`chatbot-thread/${thread_id}/messages`)
  }

  static sendMessage = (thread_id, formData) => {
    return client(
      `chatbot-thread/${thread_id}/messages`,
      { method: "POST", body: formData }
    )
  }

  static checkCompleteStatus = (thread_id, run_id) => {
    return client(`chatbot-thread/${thread_id}/runs/${run_id}`)
  }

  static getThread = (thread_id) => {
    return client(`chatbot-thread/${thread_id}`)
  }

  static createThread = () => {
    return client("chatbot-thread", { method: "POST" })
  }

  static submitToolOutputs = formData => {
    return client("submit-tool-outputs", { method: "POST", body: formData })
  }

  static runAssistant = (thread_id) => {
    return client(`chatbot-thread/${thread_id}/runs`, { method: "POST" })
  }
}
